export  class ADACodeConfigModel {
    Code: string;
    isNeedsSurface: boolean;
    isNeedsNarrative: boolean;
    isNeedsXray: boolean;
    isMayNeedReferral: boolean;
}